import { useState } from 'react';
import { Save } from 'lucide-react';
import { Slider } from '@/components/ui/slider';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export function TresholdsTabContent() {
  const [batteryLevel, setBatteryLevel] = useState(25);
  const [altitudeLimit, setAltitudeLimit] = useState(150);

  const handleSave = () => {
    // In a real app, this would make an API call
    console.log('Saving thresholds:', {
      batteryLevel,
      altitudeLimit
    });
    // Optional: Add a toast notification here
  };

  return (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold text-slate-50">
        Alert Thresholds &amp; Security
      </h3>

      {/* Battery Warning Level */}
      <div>
        <div className="flex items-center justify-between">
          <label
            htmlFor="batteryLevel"
            className="text-sm font-medium text-slate-300"
          >
            Battery Warning Level
          </label>
          <span className={cn("text-sm font-medium", "text-yellow-400")}>
            {batteryLevel}%
          </span>
        </div>
        <p className="text-xs text-slate-400">
          Alert when battery drops below this level
        </p>
        <div className="pt-2">
          <Slider
            id="batteryLevel"
            value={[batteryLevel]}
            onValueChange={(value) => setBatteryLevel(value[0])}
            min={0}
            max={100}
            step={1}
            thumbClassName="bg-yellow-400 border-yellow-400"
            rangeClassName="bg-yellow-400"
          />
        </div>
      </div>

      {/* Maximum Altitude Limit */}
      <div>
        <div className="flex items-center justify-between">
          <label
            htmlFor="altitudeLimit"
            className="text-sm font-medium text-slate-300"
          >
            Maximum Altitude Limit
          </label>
          <span className={cn("text-sm font-medium", "text-emerald-400")}>
            {altitudeLimit}m
          </span>
        </div>
        <p className="text-xs text-slate-400">
          Enforced ceiling for all flights
        </p>
        <div className="pt-2">
          <Slider
            id="altitudeLimit"
            value={[altitudeLimit]}
            onValueChange={(value) => setAltitudeLimit(value[0])}
            min={0}
            max={500}
            step={10}
            thumbClassName="bg-emerald-400 border-emerald-400"
            rangeClassName="bg-emerald-400"
          />
        </div>
      </div>

      {/* Save Changes Button */}
      <div className="flex justify-end pt-6">
        <Button
          type="button"
          onClick={handleSave}
        >
          <Save className="w-4 h-4" />
          <span>Save Changes</span>
        </Button>
      </div>
    </div>
  );
}
